import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Person from '../assets/img/account_circle_black_24dp.svg';
import Feedback from '../assets/img/rate_review_FILL0_wght400_GRAD0_opsz24.svg';
// import secureLocalStorage from 'react-secure-storage';
// import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import KEYS from '../env/env';
import { config } from '../utils/config';
import { dataURLToBlob, doRequest, userID } from '../utils/helper';
import FeedbackScreenShotModal from './FeedbackScreenShotModal';
import FeedbackOffCanvas from './FeedbackOffCanvas';
import { useDispatch, useSelector } from 'react-redux';
import { setShowFeedback, setUserData } from '../redux/slices/UserSlice';
import {
	setAllData,
	setPlanDetails,
	setVariationCountDetails,
} from '../redux/slices/PlanDetailSlice';
import { toast } from 'react-toastify';
import { trackAnalyticsEvent } from '../utils/analytics';
function Sidebar({ isOpen }) {
	const dispatch = useDispatch();
	const userplan = useSelector((state) => state.userPlan);
	const showFeedback = useSelector((state) => state.user.showFeedback);
	// console.log('userplan', userplan);
	const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
	let userLoginDetailsParsed = {};
	if (userLoginDetails) {
		userLoginDetailsParsed = JSON.parse(userLoginDetails);
	}
	let showDownloadVariations = false;
	const userPlanDetails = useSelector(
        (state) => state?.userPlan?.userPlanDetails?.[0]
    );
    const userData = useSelector((state) => state?.user?.userData);
	// const userPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS)
	// 	? JSON.parse(localStorage.getItem(config.USER_PLAN_DETAILS))
	// 	: null;
	if (userPlanDetails?.plan_id == '2') {
		let userHasPaidForVariations = localStorage.getItem('userdownloadimage')
			? JSON.parse(localStorage.getItem('userdownloadimage'))
			: null;
		if (userHasPaidForVariations) {
			let imageCanDownload = userHasPaidForVariations?.imageCanDownload;
			let downloadedCount = userHasPaidForVariations?.downloadedCount;
			if (downloadedCount < imageCanDownload) {
				showDownloadVariations = true;
			} else {
				showDownloadVariations = false;
			}
		}
	}
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const [show, setShow] = useState(false);
	const [userIsAdmin, setUserIsAdmin] = useState(userLoginDetailsParsed?.type);
	const [showScreenShot, setShowScreenShot] = useState(false);
	const [description, setDescription] = useState('');
	const [feedbackType, setFeedbackType] = useState('feedback');
	const [previewSrc, setPreviewSrc] = useState(null);
	const [showDownloadVariationsBtn, setShowDownloadVariationBtn] = useState(
		showDownloadVariations
	);
	const [feedbackLoading, setFeedbackLoading] = useState(false);
	

	const handleFeedbackType = (type) => {
		setFeedbackType(type);
	};
	const handleClose = () => {
		setShow(false)
		dispatch(setShowFeedback(false))
	};
	const handleShow = () => {
		trackAnalyticsEvent('sidebar_feedback_open', {
			source: 'left_sidebar',
		});
		setShow(true);
	};

	useEffect(() => {
		if (userLoginDetailsParsed?.type === 'admin') {
			setUserIsAdmin(true);
		} else {
			setUserIsAdmin(false);
		}
	}, [userLoginDetailsParsed]);


	useEffect(() => {
		if (showFeedback) {
			handleShow();
		}
	}, [showFeedback]);


	const handelScreenShotShow = async (isFirst) => {
		try {
			if (isFirst === true) {
				handleClose();
			}
			const stream = await navigator.mediaDevices.getDisplayMedia({
				preferCurrentTab: true,
			});

			const video = document.createElement('video');

			video.addEventListener('loadedmetadata', () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				// passing video width & height as canvas width & height
				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;

				video.play(); // playing the video so the drawn image won't be black or blank
				// drawing an image of the captured video stream
				ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
				stream.getVideoTracks()[0].stop(); // terminating first video track of the stream

				// passing canvas data url as screenshot preview src
				setPreviewSrc(canvas.toDataURL());
				// let preview = canvas.toDataURL();
				//setShowPreview(true);
			});
			video.srcObject = stream; // passing capture stream data as video source object

			setShow(true);
		} catch (error) {
			// if image couldn't capture by any reason, then alert the msg
			alert('Failed to capture screenshot!');
		}
	};
	const handelScreenShotHide = () => {
		setShowScreenShot(false);
		handleShow();
	};

	const handleLogout = () => {
		trackAnalyticsEvent('sidebar_account_logout', {
			source: 'left_sidebar',
		});
		// secureLocalStorage.removeItem('Login');
		// secureLocalStorage.removeItem(config.USER_LOGIN_DETAILS);
		localStorage.removeItem("Login");
		localStorage.removeItem(config.USER_LOGIN_DETAILS);
		localStorage.clear();
		navigate('/');
	};

	const trackSidebarNavClick = (route, section) => {
		trackAnalyticsEvent('sidebar_nav_click', {
			route,
			section,
		});
	};

	const trackAccountMenuClick = (route, section) => {
		trackAnalyticsEvent('sidebar_account_menu_click', {
			route,
			section,
		});
	};

	const sendFeedbackApi = async () => {

		const base64 = previewSrc.split(',')[1];

		setFeedbackLoading(true);
		let screenshot = '';
		var file;
		const blobData = dataURLToBlob(previewSrc);

		file = new File([blobData], `feedback_${Date.now()}.png`, {
			lastModified: new Date().getTime(),
			type: 'image/png',
		});

		const data1 = new FormData();
		data1.append('base64', base64);
		data1.append('folder', 'screenshot_images');
		data1.append('fileName', `feedback_${Date.now()}.png`);
		data1.append('mimeType', 'image/png');
		// data1.append('category', feedbackType);
		// data1.append('status', '0'); 

		// const filePayload = {
		// 	base64: base64,
		// 	folder: 'screenshot_images',
		// 	fileName: `feedback_${Date.now()}.png`,
		// 	mimeType: 'image/png',
		// }

		const requestOptions = {
			method: 'POST',
			// body: JSON.stringify(filePayload),
			body: data1,
			redirect: 'follow',
			headers: {
				// 'Authorization': `Bearer ${secureLocalStorage.getItem('Login')}`
				'Authorization': `Bearer ${localStorage.getItem('Login')}`
			}
		};

		try {
			// let response = await fetch(`${KEYS.apiPath}file/save`, requestOptions);
			let response = await fetch(`${KEYS.apiPath}file/save`, requestOptions);
			let data = await response.json();
			if (data && +data?.resultFlag === 1) {
				let imgUrl = data?.response?.url;
				screenshot = config.s3BaseUrl + '/' + imgUrl;
			} else {
			}
		} catch (error) { }

		let data = {
			comment: description,
			user_id: userID(),
			source: 'cms',
			status: 'active',
			type: feedbackType,
			image: screenshot,
		};

		let res = await doRequest(data, 'POST', 'feedback/save');
		setFeedbackLoading(false);
		toast.success("Feedback submitted successfully");
		setShow(false);
		if (+res?.result === 1) {
		}
	};

	const getUserData = async (email) => {
		try {
			const data = {
				email,
			};
			const response = await doRequest(data, 'POST', 'user/data');
			// console.log('api response is', response);
			if (response?.resultFlag == 1) {
				// console.log('inside if condition', response?.response);
				dispatch(setUserData({ userData: response?.response?.user }));
				// dispatch(setPlanDetails({userPlanDetails:response?.response?.userPlan}))
				// dispatch(setVariationCountDetails(response?.response?.variants))
				dispatch(
					setAllData({
						userPlanDetails: response?.response?.userPlan,
						variants: response?.response?.variants,
					})
				);
			}
		} catch (error) {
			console.error('user data api error is', error);
		}
	};

	useEffect(() => {
		const localDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
		if (localDetails) {
			const email = JSON.parse(localDetails)?.email;
			if (email) {
				getUserData(email);
			}
		}
	}, []);

	if (userData &&
		userPlanDetails) {
		return (
			<>
				<div className={`sidemenu ${isOpen ? 'sidemenuopen' : 'sidemenuopen2'}`}>
					<div className='text-center'>
						<ul className='nav nav-pills flex-column'>
							<li>
								<Link to='/' className='left-sidebar-logo' onClick={(e) => {
									trackSidebarNavClick('/', 'logo');
									e.preventDefault();
									window.location.href = "/";
								}}>
									<img
										src={'/assets/images/teedex-logo.png'}
										alt='Varient logo'
										className='sidebar-logo-main'
									/>
									<img
										src={'/assets/images/teedex-logo-hover.png'}
										alt='Varient logo'
										className='sidebar-logo-hover'
									/>
								</Link>

							</li>
						</ul>
					</div>

					<div className='text-center'>
						<div
						// className='scroll-area sidemenuscroll'
						>
							<div
								// className='custom-scrollbar'
								>
								<ul className='nav nav-pills flex-column mnubar_cms'>
									<li
										className={`nav-item`}>
										<Link
											to='/'
											className={`nav-link ${pathname === '/' ? 'active' : ''
												}`}
											onClick={(e) => {
												trackSidebarNavClick('/', 'home');
												e.preventDefault();
												window.location.href = "/";
											}}
											aria-current='page'>
											<div className='home_menu_flex'>
												<span>
													<img
														src={'/assets/images/homeblack.svg'}
														alt='home'
														className='homeblack'
													/>
													<img
														src={'/assets/images/homepurple.svg'}
														alt='home'
														className='homepurple'
													/>
												</span>
												<h5>Home</h5>
											</div>
										</Link>
									</li>



									{showDownloadVariationsBtn && (
										<li className='nav-item'>
											<Link
												to='/payasuse/paid/export-new'
												className={`nav-link ${pathname === '/payasuse/paid/export-new' ? 'active' : ''
													}`}
												onClick={() =>
													trackSidebarNavClick(
														'/payasuse/paid/export-new',
														'download_created_variations'
													)
												}
												aria-current='page'>
												<div className='home_menu_flex'>
													<span>
														<img
															src={'/assets/images/homeblack.svg'}
															alt='home'
															className='homeblack'
														/>
														<img
															src={'/assets/images/homepurple.svg'}
															alt='home'
															className='homepurple'
														/>
													</span>
													<h5>Download Created Variations</h5>
												</div>
											</Link>
										</li>
									)}

									{userIsAdmin && (
										<>
											<li className='nav-item'>
												<Link
													to='/admindashboard'
													className={`nav-link ${pathname === '/admindashboard' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/admindashboard', 'dashboard')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/dashboardblack.svg'}
																alt='home'
																className='homeblack'
															/>
															<img
																src={'/assets/images/dashboardpurple.svg'}
																alt='home'
																className='homepurple'
															/>
														</span>
														<h5>Dashboard</h5>
													</div>
												</Link>
											</li>

											<li className='nav-item'>
												<Link
													to='/usermanagement'
													className={`nav-link ${pathname === '/usermanagement' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/usermanagement', 'users')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/userblack.svg'}
																alt='home'
																className='homeblack'
															/>
															<img
																src={'/assets/images/userpurple.svg'}
																alt='home'
																className='homepurple'
															/>
														</span>
														<h5>Users</h5>
													</div>
												</Link>
											</li>
{/* 
											<li className='nav-item'>
												<Link
													to='/varintplans'
													className={`nav-link ${pathname === '/varintplans' ? 'active' : ''
														}`}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/plansblack.svg'}
																alt='home'
																className='homeblack'
															/>
															<img
																src={'/assets/images/planspurple.svg'}
																alt='home'
																className='homepurple'
															/>
														</span>
														<h5>Plans</h5>
													</div>
												</Link>
											</li> */}

											<li className='nav-item'>
												<Link
													to='/fontsdashboard'
													className={`nav-link ${pathname === '/fontsdashboard' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/fontsdashboard', 'fonts')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/fontblack.svg'}
																alt='home'
																className='homeblack'
															/>
															<img
																src={'/assets/images/fontblue.svg'}
																alt='home'
																className='homepurple'
															/>
														</span>
														<h5>Fonts</h5>
													</div>
												</Link>
											</li>

											<li className='nav-item'>
												<Link
													to='/varintfaq'
													className={`nav-link ${pathname === '/varintfaq' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/varintfaq', 'faq')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/faqblack.svg'}
																alt='home'
																className='homeblack'
															/>
															<img
																src={'/assets/images/faqpurple.svg'}
																alt='home'
																className='homepurple'
															/>
														</span>
														<h5>F&Q</h5>
													</div>
												</Link>
											</li>

											<li className='nav-item'>
												<Link
													to='/admin/user-files'
													className={`nav-link ${pathname === '/admin/user-files' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/admin/user-files', 'user_files')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/dashboardblack.svg'}
																alt='files'
																className='homeblack'
															/>
															<img
																src={'/assets/images/dashboardpurple.svg'}
																alt='files'
																className='homepurple'
															/>
														</span>
														<h5>User Files</h5>
													</div>
												</Link>
											</li>

											<li className='nav-item'>
												<Link
													to='/admin/user-designs'
													className={`nav-link ${pathname === '/admin/user-designs' ? 'active' : ''
														}`}
													onClick={() =>
														trackSidebarNavClick('/admin/user-designs', 'user_designs')
													}
													aria-current='page'>
													<div className='home_menu_flex'>
														<span>
															<img
																src={'/assets/images/dashboardblack.svg'}
																alt='designs'
																className='homeblack'
															/>
															<img
																src={'/assets/images/dashboardpurple.svg'}
																alt='designs'
																className='homepurple'
															/>
														</span>
														<h5>User Designs</h5>
													</div>
												</Link>
											</li>

										</>
									)}





									{!userIsAdmin && (
										<li className='nav-item'>
											<Link
												to='/mydesigns'
												className={`nav-link ${pathname === '/mydesigns' ? 'active' : ''
													}`}
												onClick={() =>
													trackSidebarNavClick('/mydesigns', 'my_designs')
												}
												aria-current='page'>
												<div className='home_menu_flex'>
													<span>
														<img
															src={'/assets/images/design-icn.svg'}
															alt='home'
															className='homeblack'
															style={{ height: '25px', width: '25px' }}
														/>
														<img
															src={'/assets/images/design-icn.svg'}
															alt='home'
															className='homepurple'
															style={{ height: '25px', width: '25px' }}
														/>
													</span>
													<h5>Designs</h5>
												</div>
											</Link>
										</li>
									)}



								</ul>
							</div>
						</div>
					</div>

					<div className='text-center'>
						<ul className='nav nav-pills flex-column user_profile'>
							<li className='nav-item'>
								<div className='dropup'>
									<button
										type='button'
										className='dropdown-toggle'
										data-bs-toggle='dropdown'>
										<div className='user_profile_img'>
											<img
												src={
													userLoginDetailsParsed &&
														userLoginDetailsParsed?.user_image
														? userLoginDetailsParsed?.user_image
														: Person
												}
												alt='home'
												className='user_image_shape'
											/>
										</div>
										{/* {userLoginDetailsParsed?.first_name ? (
											<h5>{userLoginDetailsParsed?.first_name}</h5>
										) : (
											<h5>User</h5>
										)} */}
										<h5>
										{userLoginDetailsParsed?.first_name
											? userLoginDetailsParsed.first_name.length > 10
											? `${userLoginDetailsParsed.first_name.slice(0, 8)}…`
											: userLoginDetailsParsed.first_name
											: "User"}
										</h5>

									</button>
									<ul className='dropdown-menu dropmenu_cust'>
										<li>
											<Link
												to={'/profile'}
												className='dropdown-item'
												onClick={() =>
													trackAccountMenuClick('/profile', 'my_profile')
												}>
												<img
													src={'/assets/images/myprofile.svg'}
													alt=''
													className=''
												/>{' '}
												My Profile
											</Link>
										</li>
										<li>
											<Link
												className='dropdown-item'
												to={'/sizes'}
												onClick={() =>
													trackAccountMenuClick('/sizes', 'change_size')
												}>
												<img
													src={'/assets/images/size-setting.svg'}
													alt=''
													className=''
												/>
												Change Size
											</Link>
										</li>
										<li>
											<Link
												className='dropdown-item'
												to={'/billing-history'}
												onClick={() =>
													trackAccountMenuClick(
														'/billing-history',
														'billing_history'
													)
												}>
												<img
													src={'/assets/images/billinghistory.svg'}
													alt=''
													className=''
												/>
												Billing history
											</Link>
										</li>

										<li>
											<Link
												to={'/plans'}
												className='dropdown-item'
												onClick={() =>
													trackAccountMenuClick('/plans', 'plans')
												}>
												<img
													src={'/assets/images/variantdrop.svg'}
													alt=''
													className=''
												/>
												Teedex Plans
											</Link>
										</li>

										<li
											onClick={() => {
												handleLogout();
											}}
											className='logout_brd'>
											<Link className='dropdown-item' href='#'>
												<img
													src={'/assets/images/logout.svg'}
													alt=''
													className=''
												/>
												Logout
											</Link>
										</li>
									</ul>
								</div>
							</li>

							<li className='nav-item'>
								<Link
									to='#'
									className='leavefed_modal'
									onClick={() => {
										handleShow();
									}}>
									<span>
										<img src={Feedback} alt='home' />
									</span>
									<span>Leave<br />Feedback</span>
								</Link>
							</li>
						</ul>
					</div>


				</div>


				{show && (
					<FeedbackOffCanvas
						previewSrc={previewSrc}
						handleFeedbackType={handleFeedbackType}
						feedbackType={feedbackType}
						description={description}
						setDescription={setDescription}
						key={1}
						placement={'end'}
						name={'end'}
						sendFeedbackApi={sendFeedbackApi}
						handleClose={handleClose}
						show={show}
						handelScreenShotShow={handelScreenShotShow}
						loading={feedbackLoading}
					/>
				)}
				{showScreenShot && (
					<FeedbackScreenShotModal
						handelScreenShotHide={handelScreenShotHide}
						showScreenShot={showScreenShot}
					/>
				)}
			</>
		)
	};

	return null;
}

export default Sidebar;
